import Component from '../Component';
import * as eventNames from '../../customEventStrings';
import * as uiStrings from '../../uiStrings';

class PrintButton extends Component {
	constructor() {
		super();
	}

	componentDidMount() {
		this.setupEventListeners();
	}

	setupEventListeners() {
		// simulate button:active state
		this.refs['print-btn'].addEventListener('mousedown', () => {
			this.refs['print-btn'].classList.add('active');
		});

		this.refs['print-btn'].addEventListener('mouseup', () => {
			this.refs['print-btn'].classList.remove('active');
		});

		this.refs['print-btn'].addEventListener('click', (e) => {
			this.dispatchCustomEvent(eventNames.PRINT_MAP, e.target);
		});
	}

	render() {
		return `
            <div ref="print-btn" class="control-button print--button js-print-button">
                <div class="control-button__icon" title="${uiStrings.DOWNLOAD_MAP}">
                    <i class="fas fa-download fa-2x"></i>
                </div>
            </div>`;
	}
}

export default PrintButton;
